module.exports = "/_next/static/images/PersonalizeOnEveryChannel-40fc624e642c63c45966ac07f1e97694.webp";